var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconContactViewedPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-contact-viewed-page") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Onboarding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "13-Contact-detail",
    transform: "translate(-290.000000, -332.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-contact-viewed-page",
    transform: "translate(290.000000, 332.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#090B45",
    strokeWidth: 0.888888889,
    fill: "#FFFFFF",
    x: 0.444444444,
    y: 0.444444444,
    width: 15.1111111,
    height: 15.1111111,
    rx: 2.66666667
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons8-visible",
    transform: "translate(2.666667, 7.555556)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#090B45",
    fillRule: "nonzero",
    cx: 5.33333333,
    cy: 2.28571429,
    r: 1.14285714
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6666667,2.66666667 C10.6666667,2.66666667 8.27885714,5.33333333 5.33333333,5.33333333 C2.38780952,5.33333333 0,2.66666667 0,2.66666667 C0,2.66666667 2.38780952,0 5.33333333,0 C8.27885714,0 10.6666667,2.66666667 10.6666667,2.66666667 Z",
    id: "Path",
    stroke: "#090B45",
    strokeWidth: 0.761904762
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91314286,0.66247619 C8.20952381,1.13257143 8.38095238,1.68914286 8.38095238,2.28571429 C8.38095238,3.9687619 7.01638095,5.33333333 5.33333333,5.33333333 C3.65028571,5.33333333 2.28571429,3.9687619 2.28571429,2.28571429 C2.28571429,1.7192381 2.44038095,1.18895238 2.70933333,0.73447619",
    id: "Path",
    stroke: "#090B45",
    strokeWidth: 0.761904762
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.444444444,4.88888889 L15.5555556,4.88888889 L15.5555556,2.66666667 C15.5555556,1.43936722 14.5606328,0.444444444 13.3333333,0.444444444 L2.66666667,0.444444444 C1.43936722,0.444444444 0.444444444,1.43936722 0.444444444,2.66666667 L0.444444444,4.88888889 Z",
    id: "Rectangle",
    stroke: "#090B45",
    strokeWidth: 0.888888889,
    fill: "#B2C1DF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#090B45",
    cx: 2.66666667,
    cy: 2.66666667,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#090B45",
    cx: 5.33333333,
    cy: 2.66666667,
    r: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#090B45",
    x: 8,
    y: 1.77777778,
    width: 5.33333333,
    height: 1.77777778,
    rx: 0.888888889
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContactViewedPage);
export default __webpack_public_path__ + "static/media/icon-contact-viewed-page.dcd81b1f1cacd7e0bb63307f45c6ee60.svg";
export { ForwardRef as ReactComponent };